import React,{forwardRef,useEffect,useImperativeHandle,useRef} from 'react';

// Cloudflare Turnstile (sign-up bot check). Renders only when
// REACT_APP_TURNSTILE_SITE_KEY is set; the backend verifies the token when its
// TURNSTILE_SECRET_KEY is set. Tokens are single-use, so call reset() after a
// failed sign-up.
export const TURNSTILE_SITE_KEY=process.env.REACT_APP_TURNSTILE_SITE_KEY||'';
const SCRIPT='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let loading:Promise<void>|null=null;
function load(){
  if((window as any).turnstile) return Promise.resolve();
  loading??=new Promise<void>((resolve,reject)=>{const s=document.createElement('script');s.src=SCRIPT;s.async=true;s.defer=true;s.onload=()=>resolve();s.onerror=()=>{loading=null;reject(new Error('Turnstile failed to load'));};document.head.appendChild(s);});
  return loading;
}
export type TurnstileHandle={reset:()=>void};
const Turnstile=forwardRef<TurnstileHandle,{onToken:(token:string)=>void}>(function Turnstile({onToken},ref){
  const box=useRef<HTMLDivElement>(null),widget=useRef<string|null>(null),callback=useRef(onToken);
  callback.current=onToken;
  useImperativeHandle(ref,()=>({reset:()=>{const t=(window as any).turnstile;if(t&&widget.current!==null){t.reset(widget.current);callback.current('');}}}),[]);
  useEffect(()=>{
    if(!TURNSTILE_SITE_KEY) return;
    let active=true;
    load().then(()=>{
      const t=(window as any).turnstile;
      if(!active||!box.current||!t) return;
      widget.current=t.render(box.current,{sitekey:TURNSTILE_SITE_KEY,callback:(token:string)=>callback.current(token),'expired-callback':()=>callback.current(''),'error-callback':()=>callback.current('')});
    }).catch(()=>{});
    return()=>{active=false;const t=(window as any).turnstile;if(t&&widget.current!==null)t.remove(widget.current);widget.current=null;};
  },[]);
  return TURNSTILE_SITE_KEY?<div className="account-turnstile" ref={box}/>:null;
});
export default Turnstile;
